import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance";


export class UserRewardApiService {
    private readonly userRewardBaseUrl: string;

    constructor() {
        this.userRewardBaseUrl = ApiConstants().userReward;
    }

    async claimReward(id: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.userRewardBaseUrl}${id}/claim`,
            requiresToken: true,
        });
        return response;
    }
} 